import apiFetch from '../apiFetch'

export default function (value, token) {
  return apiFetch({endPoint: `ImportarPedidosExcel/descargarPlantillaExcelPedidosExcel`, method: 'GET', body: null, token: token})
}
